import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getHeaderTitle", "actionMetadata", "actionId"];
import { Component } from 'react';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import WhileLoopActionDetail from 'automation-ui-action-features/actions/while-loop/WhileLoopActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
class WhileLoopActionCard extends Component {
  render() {
    const _this$props = this.props,
      {
        getHeaderTitle,
        actionMetadata,
        actionId
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
      headerTitle: actionId && getHeaderTitle({
        actionId
      }),
      content: /*#__PURE__*/_jsx(WhileLoopActionDetail, {
        actionMetadata: actionMetadata
      })
    }));
  }
}
export default WhileLoopActionCard;